module.exports = {"Type":"SwitchChannel","Disabled":false,"Fields":[],"Header":{"Color":"white","BackgroundColor":"orange","Text":""}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/SwitchChannel.json
// module id = 674
// module chunks = 0